import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  getDocs, 
  addDoc, 
  query, 
  orderBy, 
  serverTimestamp,
  updateDoc,
  doc,
  increment 
} from "firebase/firestore";
import { Suggestion, ProofItem } from "../types";

const firebaseConfig = { 
  apiKey: "AIzaSyCadpU4RKaj2k6buiJD96DwbYLhw1XDPw8", 
  authDomain: "memecoin-castle.firebaseapp.com", 
  projectId: "memecoin-castle", 
  storageBucket: "memecoin-castle.firebasestorage.app", 
  messagingSenderId: "211947577032", 
  appId: "1:211947577032:web:1b85cfeca1e245faf6cffd", 
  measurementId: "G-SNF0T0999C" 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Collection References
const SUGGESTIONS_COLLECTION = 'community_suggestions';
const PROOFS_COLLECTION = 'proof_board';

// --- Service Functions ---

export const getSuggestions = async (): Promise<Suggestion[]> => {
  try {
    const q = query(collection(db, SUGGESTIONS_COLLECTION), orderBy("votes", "desc"));
    const querySnapshot = await getDocs(q);
    const suggestions: Suggestion[] = [];
    querySnapshot.forEach((doc) => {
      suggestions.push({ id: doc.id, ...doc.data() } as Suggestion);
    });
    return suggestions;
  } catch (error) {
    console.error("Error getting suggestions: ", error);
    return [];
  }
};

export const addSuggestion = async (text: string, author: string = 'Anonymous'): Promise<boolean> => {
  try {
    await addDoc(collection(db, SUGGESTIONS_COLLECTION), {
      text,
      author,
      votes: 0,
      createdAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error("Error adding suggestion: ", error);
    return false;
  }
};

export const voteSuggestion = async (id: string): Promise<boolean> => {
  try {
    const docRef = doc(db, SUGGESTIONS_COLLECTION, id);
    await updateDoc(docRef, {
      votes: increment(1)
    });
    return true;
  } catch (error) {
    console.error("Error voting: ", error);
    return false;
  }
};

export const getProofs = async (): Promise<ProofItem[]> => {
  try {
    const q = query(collection(db, PROOFS_COLLECTION), orderBy("date", "desc"));
    const querySnapshot = await getDocs(q);
    const proofs: ProofItem[] = [];
    
    querySnapshot.forEach((doc) => {
      proofs.push({ id: doc.id, ...doc.data() } as ProofItem);
    });
    return proofs;
  } catch (error) {
    console.error("Error getting proofs: ", error);
    return [];
  }
};